<template>
  <section class="section container pt-3">
    <div class="title is-3 has-text-centered">{{ $t("scheduled trips") }}</div>
    <full-calendar
      :options="calendarOptions"
      ref="full_calendar"
    ></full-calendar>
  </section>
  <event-modal ref="event_modal" @success="refresh"></event-modal>
</template>

<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { api_host, get, error_message, post } from "@/utils";
import EventModal from "./event_modal/Index.vue";

export default {
  name: "ScheduledIndex",
  components: { FullCalendar, EventModal },
  data() {
    let v = this;
    return {
      calendarOptions: {
        locale: v.$i18n.locale,
        customButtons: {
          refresh: {
            text: v.$t("refresh"),
            click: function () {
              v.refresh();
            },
          },
        },
        eventSources: [
          // your event source
          // {
          //   url: `${api_host}/calendar/event/all`, // use the `url` property
          //   color: "yellow", // an option!
          //   textColor: "black", // an option!
          // },
          {
            events: function (info, success, failure) {
              // console.log("events", info);
              get("/trip/scheduled/all", {
                start_date: info.start,
                end_date: info.end,
              })
                .then((response) => {
                  let arr = response.map((event) => {
                    let evt = {
                      id: event.uuid,
                      title: `(${event.trip_assigns.length}) ${event.origin} - ${event.destination}`,
                      start: event.departure_date,
                      end: event.return_date,
                      allDay: false,
                      display: "block",
                      modul_evt: event,
                      // color: event.settings.color,
                    };
                    return evt;
                  });
                  success(arr);
                })
                .catch((error) => {
                  error_message(error);
                  failure(error);
                });
            },
          },
        ],
        editable: true,
        nowIndicator: true,
        // now: true,
        buttonText: {
          today: v.$t("today"),
          month: v.$t("month"),
          week: v.$t("week"),
          day: v.$t("day"),
        },
        footerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        headerToolbar: {
          left: "prev,next today refresh",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: "dayGridMonth",
        dateClick: v.date_click,
        eventClick: v.event_click,
        eventChange: v.event_change,
      },
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    date_click: function (arg) {
      let v = this;
      v.$refs.event_modal.create_event(arg);
    },
    event_click: function (info) {
      let v = this;
      v.$refs.event_modal.edit_event(info.event._def.publicId);
    },
    event_change: function (info) {
      let v = this;
      post("/calendar/event", {
        uuid: info.event._def.publicId,
        start_date: info.event.start,
        end_date: info.event.end,
      })
        .then(() => {
          v.refresh();
        })
        .catch((error) => {
          console.error(error);
          error_message(error);
        });
    },
    refresh() {
      let v = this;
      let api = v.$refs.full_calendar.getApi();
      api.refetchEvents();
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
